module.exports = __webpack_public_path__ + "assets/images/Order_Type_C_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_C_Icon.png
// module id = 1423
// module chunks = 1